import React from 'react';
import {
  Select,
  FormControl,
  FormLabel,
  HStack,
  Spinner
} from '@chakra-ui/react';
import { useEntity } from '../contexts/EntityContext';
import { useLanguage } from '../contexts/LanguageContext';

const EntitySelector = ({ size = 'md', showLabel = false, variant = 'outline', onChange }) => {
  const { currentEntity, availableEntities, loading, changeEntity } = useEntity();
  const { t } = useLanguage();

  // Always show selector, but disable if only one entity or loading
  const isDisabled = loading || availableEntities.length <= 1;

  const handleEntityChange = (event) => {
    const entityId = parseInt(event.target.value);
    const entity = availableEntities.find(e => e.id === entityId);
    if (entity) {
      if (onChange) {
        onChange(entity);
      } else {
        changeEntity(entity);
      }
    }
  };

  return (
    <FormControl>
      {showLabel && (
        <FormLabel fontSize={size === 'sm' ? 'sm' : 'md'}>
          {t('entity.select', { defaultValue: 'Entity' })}
        </FormLabel>
      )}
      <HStack spacing={2}>
        <Select
          value={currentEntity?.id || ''}
          onChange={handleEntityChange}
          size={size}
          variant={variant}
          isDisabled={isDisabled}
          minW="150px"
          title={isDisabled && availableEntities.length <= 1 ? t('entity.only_one_entity', { defaultValue: 'Only one entity available' }) : ''}
        >
          {availableEntities.map((entity) => (
            <option key={entity.id} value={entity.id}>
              {entity.name}
            </option>
          ))}
        </Select>
        {loading && <Spinner size="sm" />}
      </HStack>
    </FormControl>
  );
};

export default EntitySelector;

